import React from "react";
import {useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {MenuButton, MenuButtonItem} from "@/lib/components/buttons/MenuButton";
import {GebaeudeIcon} from "@/agentur/AgenturIcons";
import {CommonI18N} from "@/translations";
import {useCompanySwitcher} from "@/app/header/useCompanySwitcher";

/**
 * Renders a dropdown in the header that allows the user to switch the active company.
 *
 * Uses the useCompanySwitcher hook to obtain the list of available companies and the
 * current selection. The component renders nothing when fewer than two companies are
 * available, since switching would have no effect.
 */
export const CompanySwitcher: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { availableCompanies, activeCompany, switchCompany } = useCompanySwitcher();

    if (availableCompanies.length === 0) {
        return null;
    }

    const menuItems: MenuButtonItem[] = availableCompanies.map((c) => ({
        label: c.name ?? "–",
        icon: <GebaeudeIcon mode={theme.palette.mode} />,
        content: () => switchCompany(c.id!)
    }));

    return (
        <MenuButton
            noUpperText
            icon={<GebaeudeIcon mode={theme.palette.mode} />}
            text={activeCompany?.name ?? t(CommonI18N.header.action.switchCompany)}
            menu={menuItems}
        />
    );
};
